import { React, useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { Dialog, DialogTitle, Snackbar, Alert } from "@mui/material";
import "../../styles/ResearchApplicantCreate.css";

function ResearchAppliantCreate(props) {

  const { pid, researchPosition, updateApply, setUpdateApply } = props;

  const getStudentProfileDetails = () => {
    const body = new FormData();
    body.append("pid", pid);
    axios.post("/student/profile", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setStudentData(data.profile);
      } else {
        setStudentData({});
      }
    });
  };

  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [researchAppliantDetails, setResearchAppliantDetails] = useState("");
  const [studentData, setStudentData] = useState({});

  const handleApplyResearchPosition = (event) => {

    event.preventDefault();

    const body = new FormData();
    body.append("pid", pid);
    body.append("positionId", researchPosition.positionId);
    body.append("researchAppliantDetails", researchAppliantDetails);

    axios.post("/student/applyResearchPosition", body).then((res) => {
      const data = res.data;
      if (data.success) {
        resetHooks();
        setOpenEditDialog(false);
        researchPosition.apply = false;
      } else {
        setSnackbarMessage(data.message);
        setSnackbarOpen(true);
      }
    });
  };

  const resetHooks = () => {
    setResearchAppliantDetails("");
  };

  useEffect(() => {
    getStudentProfileDetails();
  }, []);

  let url = window.location.href;
  let homeUrl = url.split("/researchpositions");
  let profileUrl = homeUrl[0].concat("/profile");

  function showEditDialog() {
    const isProfileComplete = studentData.first_name && studentData.last_name && studentData.email && studentData.grad_year && studentData.resume && studentData.major_minor;
    return (
      <Dialog open={openEditDialog} maxWidth={false}>
        <DialogTitle className="ResearchAppliantApply-title mx-auto text-2xl font-bold font-brand-primary">
          Apply to Research Position Posting
        </DialogTitle>
        <div className="ResearchAppliantApply-modalContainer flex w-fit mb-4 mx-4">
          <div className="ResearchAppliantApply-modalLeftContainer flex flex-col w-fit">
            <div className="ResearchPositionEdit-researchPositionDescriptionContainer flex flex-col w-96 mx-4 mb-2">
              <div className="ResearchPositionEdit-researchPositionDescriptionTitle text-lg font-brand-primary">
                Details from your profile:
              </div>
              <div className="indent">
                First Name: {studentData.first_name}
              </div>
              <div className="indent">
                Last Name: {studentData.last_name}
              </div>
              <div className="indent">
                Email: {studentData.email}
              </div>
              <div className="indent">
                Graduation Year: {studentData.grad_year}
              </div>
              <div className="indent">
                Major/Minor: {studentData.major_minor}
              </div>
              <div className="indent">
                {studentData.resume !== "resume.pdf" && (
                  <div>Resume: {studentData.resume}</div>
                )}
              </div>
              <div className={isProfileComplete ? "text-sm" : "text-md"}>
                {isProfileComplete
                  ? "Note: You can change these in your "
                  : "Note: To apply, these fields must be set in your "
                }
                {<a href={profileUrl} style={{ color: "blue", textDecoration: "underline" }} rel="noopener noreferrer">profile</a>}
              </div>
              {isProfileComplete && (
              <div style={{ paddingTop: "4px" }}>
                <div className="ResearchPositionEdit-researchPositionDescriptionTitle text-lg font-brand-primary">
                  Why should we choose you for this position?
                </div>
              </div>)}
              {isProfileComplete && (<textarea
                value={researchAppliantDetails}
                onChange={(event) => {
                  if (event.target.value.length <= 10000) {
                    setResearchAppliantDetails(event.target.value);
                  }
                }}
                className="rounded-xl bg-white p-2 border border-gray-300"
                type="textarea"
                placeholder="Please add details about yourself here!"
                required={true}
              />)}
            </div>
          </div>
        </div>
        {isProfileComplete ? (<div className="ResearchPositionEdit-buttonContainer flex justify-between px-8 mb-4">
          <button
            type="button"
            className="primary-button bg-brand-quaternary mb-2 h-11 pt-3"
            onClick={(event) => handleApplyResearchPosition(event, false)}
          >
            Apply
          </button>
          <button
            type="button"
            className="primary-button bg-brand-primary  mb-2 h-11 pt-3"
            onClick={resetHooks}
          >
            Reset
          </button>
          <button
            type="button"
            className="primary-button bg-brand-primary mb-2 h-11 pt-3"
            onClick={() => {
              setOpenEditDialog(false);
              resetHooks();
            }}
          >
            Cancel
          </button>
        </div>) : (<div className="ResearchPositionEdit-buttonContainer flex justify-center px-8 mb-4">
          <button
            type="button"
            className="primary-button bg-brand-primary mb-2 h-11 pt-3"
            onClick={() => {
              setOpenEditDialog(false);
              resetHooks();
            }}
            style={{
              // Optional: If you want to adjust the width slightly less than full
              width: "90%", // Adjust the percentage as needed
              padding: "1rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Cancel
          </button>
        </div>)}
        <Snackbar
          open={snackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => {
            setSnackbarOpen(false);
            setSnackbarMessage("");
          }
          }
        >
          <Alert
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }
            }
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Dialog>
    );
  }

  return (

    <div className="ResearchPositionCreate-container">
      {showEditDialog()}
      <button
        type="button"
        onClick={() => researchPosition.apply && setOpenEditDialog(true)}
        disabled={!researchPosition.apply}
        className={`primary-button ${!researchPosition.apply ? "bg-gray-500 text-white" : "bg-brand-primary text-white"} w-fit`}
      >
        {researchPosition.apply ? (
          <span>Apply</span>
        ) : (
          <span>Already Applied</span>
        )}
      </button>
      <Snackbar onClose={() => setSnackbarOpen(false)} />
    </div>
  );
}

ResearchAppliantCreate.propTypes = {
  pid: PropTypes.string.isRequired,
  researchPosition: PropTypes.shape({
    positionId: PropTypes.number, 
    apply: PropTypes.bool
  }),
  updateApply: PropTypes.bool, 
  setUpdateApply: PropTypes.func
};

export default ResearchAppliantCreate;
